/**
 * La configuración del entorno, leída una vez y validada al arrancar.
 *
 * Falla ruidosamente si falta algo: una variable OIDC vacía produciría un login
 * que redirige a ninguna parte, y ese fallo aparece tarde y confunde. Mejor no
 * arrancar.
 */
function requerido(nombre: string, valor: string | undefined): string {
  if (!valor) {
    throw new Error(
      `Falta la variable de entorno ${nombre}. Copia .env.example a .env y complétala.`,
    );
  }
  return valor;
}

export interface AppConfig {
  /** Raíz de la API. En desarrollo va vacía: Vite hace de proxy en /api. */
  apiBaseUrl: string;
  /**
   * El tenant sobre el que opera este despliegue. Farmacenter es
   * monotenant: no hay un listado de tenants que elegir (sería una operación
   * cross-tenant de administración), así que el tenant se fija por configuración
   * una vez y el selector de contexto arranca en la entidad legal.
   */
  tenantId: string;
  oidc: {
    authority: string;
    clientId: string;
    redirectUri: string;
  };
}

export const config: AppConfig = {
  // Vacío en desarrollo: las rutas del contrato ya empiezan por /api, y el proxy
  // de Vite las reenvía. En producción se apunta a https://erp.farmacentercerete.com.
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  tenantId: requerido("VITE_TENANT_ID", import.meta.env.VITE_TENANT_ID),
  oidc: {
    authority: requerido("VITE_OIDC_AUTHORITY", import.meta.env.VITE_OIDC_AUTHORITY),
    clientId: requerido("VITE_OIDC_CLIENT_ID", import.meta.env.VITE_OIDC_CLIENT_ID),
    redirectUri: requerido("VITE_OIDC_REDIRECT_URI", import.meta.env.VITE_OIDC_REDIRECT_URI),
  },
};
